export default __webpack_public_path__ + "img/birthday.472e1232.png";